import { LegalEntityType, LegalEntityWithRepresentativeType } from "../../types/commonTypes/legalEntityType";

// personne moral
export const initialLegalEntityState: LegalEntityType = {
    rcs: "",
    companyName: "",
    legalForm: "",
    capital: 0,
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    isRcsRegistering: false,
    cities: []
}


// personne morale avec representateur
export const LegalEntityWithRepresentativeInitialState: LegalEntityWithRepresentativeType = {
    rcs: "",
    companyName: "",
    legalForm: "",
    capital: 0,
    postalCode: "",
    city: "",
    address: "",
    additionalAddress: "",
    registrationOffice: "",
    isRcsRegistering: false,
    cities: [],
    civility: "Monsieur",
    lastName: "",
    firstName: ""
}